module.exports = __webpack_public_path__ + "static/media/dobleProducto.eb6031cb.png";